import axios from 'axios';
import {
  ADD_TRANSLATION_TABLE,
  ADD_TT_COL_LIST_ITEM,
  ADD_TT_COLUMN,
  ADD_TT_ROW,
  DELETE_TT_COL_LIST_ITEM,
  SAVE_TRANSLATION_TABLE,
  SAVING_TRANSLATION_TABLE,
  UPDATE_INPUT_FIELD_DATA,
  UPDATE_SOURCE_COLUMN,
  UPDATE_TRANSLATION_TABLE,
  UPDATE_TT_COL_LIST_ITEM,
  FETCH_TT_COL_LIST_ITEMS,
  CHANGING_COL_LIST,
  CHANGING_COL_LIST_SUCCESS,
  SAVE_MATCH_COL_LIST_SUCCESS,
  FETCH_TT_DATA,
  FETCHING_TT_DATA,
  DELETE_TRANSLATION_TABLE_SUCCESS,
  RESET_TRANSLATION_TABLE, CANCEL_MATCH_COL_LIST,
  CLEAR_ROWS,
  FETCHING_TRANSLATION_TABLE,
  SET_TT_EDITION_MODE,
  RESET_TT_EDITION_MODE,
  FETCH_TRANSLATION_TABLE_SUCCESS,
  CLEAR_LIST_ITEMS,
  UPDATE_TARGET_COLUMN, 
  FETCHING_ALL_TRANSLATION_TABLES,
  FETCH_ALL_TRANSLATION_TABLES_SUCCESS
} from './TranslationTableConstants';
import { ADD_UNCONFIRMED_TRANSLATION_TABLE } from "redux/profileTranslationTables/ProfileTranslationTablesConstants";
import { uploadFiles } from '../files/FilesActions';

const createColumnSuccess = sourceColumn => ({ type: ADD_TT_COLUMN, sourceColumn });
const createTranslationTableSuccess = (translationTable, sourceColumn, targetColumn, sourceInput, targetInput) => ({ type: ADD_TRANSLATION_TABLE, translationTable, sourceColumn, targetColumn, sourceInput, targetInput });
const createRowSuccess = rows => ({ type: ADD_TT_ROW, rows });
const updateInputFieldDataSuccess = () => ({ type: UPDATE_INPUT_FIELD_DATA });
const updateSourceColumnSuccess = (data, index) => ({ type: UPDATE_SOURCE_COLUMN, data, index });
const saveTranslationTableSuccess = translationTable => ({ type: SAVE_TRANSLATION_TABLE, translationTable});
const addUnconfirmedTranslationTable = translationTable => ({ type: ADD_UNCONFIRMED_TRANSLATION_TABLE, translationTable});
const savingTranslationTable = () => ({ type: SAVING_TRANSLATION_TABLE });
const createMatchColListItemSuccess = (matchColListItem, sourceInputId) => ({ type: ADD_TT_COL_LIST_ITEM, matchColListItem, sourceInputId });
const updateMatchColListItemSuccess = (matchColListItem, sourceInputId) => ({ type: UPDATE_TT_COL_LIST_ITEM, matchColListItem, sourceInputId });
const deleteMatchColListItemSuccess = (id, sourceInputId) => ({ type: DELETE_TT_COL_LIST_ITEM, id, sourceInputId });
const fetchMatchColListItemSuccess = (matchColListItems, sourceInputId) => ({ type: FETCH_TT_COL_LIST_ITEMS, matchColListItems, sourceInputId });
const fetchingTranslationTableData = rows => ({ type: FETCHING_TT_DATA, rows });
const fetchTranslationTableDataSuccess = rows => ({ type: FETCH_TT_DATA, rows });
const changingColList = () => ({ type: CHANGING_COL_LIST });
const changingColListSuccess = () => ({ type: CHANGING_COL_LIST_SUCCESS });
const saveMatchColListSuccess = sourceInputId => ({ type: SAVE_MATCH_COL_LIST_SUCCESS, sourceInputId });
const deleteTranslationTableSuccess = () => ({ type: DELETE_TRANSLATION_TABLE_SUCCESS });
const cancelMatchColListSuccess = sourceInputId => ({ type: CANCEL_MATCH_COL_LIST, sourceInputId });
const clearRows = () => ({ type: CLEAR_ROWS });
const fetchingTranslationTable = () => ({ type: FETCHING_TRANSLATION_TABLE });
const fetchTranslationTableSuccess = translationTable => ({ type: FETCH_TRANSLATION_TABLE_SUCCESS, translationTable });
export const setTranslationTableEditionMode = () => ({ type: SET_TT_EDITION_MODE });
export const resetTranslationTableEditionMode = () => ({ type: RESET_TT_EDITION_MODE });
const resetTranslationTableSuccess = () => ({ type: RESET_TRANSLATION_TABLE });
export const clearMatchColListItems = () => ({ type: CLEAR_LIST_ITEMS });
const updateTargetColumnSuccess = data => ({ type: UPDATE_TARGET_COLUMN, data });
const fetchingAllTranslationTables = () => ({ type: FETCHING_ALL_TRANSLATION_TABLES });
const fetchAllTranslationTablesSuccess = () => ({ type: FETCH_ALL_TRANSLATION_TABLES_SUCCESS });

const url = 'utm/v1/transl-tbls';
const colUrl = '/cols';
const translateDataUrl = '/translate-data';
const matchCols = '/match-cols';
const matchColsList = '/match-col-list';
const ttFileList = '/tt-file-list';
const fileList = '/file-list';
const consolidated = 'consolidated';

export const cancelTranslationTable = translationTableId => dispatch => {
  dispatch(fetchingAllTranslationTables());
  axios.put(`${ url }/${ translationTableId }`)
    .then(() => {
      dispatch(fetchAllTranslationTablesSuccess());
      dispatch(resetTranslationTableSuccess());
    })
    .catch(err => { throw err; });
};

export const createColumn = (type, tTableId) => dispatch => {
  axios.post(url+colUrl, { type, tTableId }).then(response => {
    dispatch(createColumnSuccess({ id: response.data.data.id }));
  });
};

export const createTranslationTable = () => dispatch => {
  dispatch(resetTranslationTableSuccess());
  axios.post(url)
    .then(response => {
      const { ttId, ttcMatchId, ttcTargetId, ttmcId, tttdId } = response.data.data;
      dispatch(createTranslationTableSuccess({ id: ttId }, { id: ttcMatchId }, { id: ttcTargetId }, { id: ttmcId, matchValue: '' }, { id: tttdId, translValue: '' })); 
    })
    .catch(err => { throw err; });
};

export const deleteTranslationTable = translationTableId => dispatch => {
  dispatch(fetchingAllTranslationTables());
  axios.delete(`${ url }/${ translationTableId }`)
    .then(() => {
      dispatch(fetchAllTranslationTablesSuccess());
      dispatch(deleteTranslationTableSuccess());
    }).catch(err => { throw err; });
};

export const fetchTranslationTableData = translationTableId => dispatch => {
  dispatch(fetchingTranslationTableData());
  axios.get(`${ url+translateDataUrl }/transl-tbls/${ translationTableId }`)
    .then(response => {
      dispatch(fetchTranslationTableDataSuccess(response.data.data));
    })
    .catch(err => { throw err; });
};

export const createRow = (sourceColumns, targetColumn) => dispatch => {
  const params = {
    matchColumnDtoList: sourceColumns.map(sourceColumn => ({
      translationTableColumnId: sourceColumn.id
    })),
    translateDataDto: {
      translationTableColumnId: targetColumn.id
    }
  };
  axios.post(url+translateDataUrl, params)
    .then(response => {
      if(response.status === 200) {
        dispatch(clearRows());
        dispatch(createRowSuccess(response.data.data));
      }
    }).catch(err => { throw err; });
};

export const updateSourceInputFieldData = (id, data) => dispatch => {
  axios.put(url+matchCols, { id, confirmedValue: data })
    .then(() => {
      dispatch(updateInputFieldDataSuccess());
    })
    .catch(err => { throw err; });
};

export const updateTargetInputFieldData = (id, data) => dispatch => {
  axios.put(url+translateDataUrl, { id, confirmedValue: data })
    .then(() => {
      dispatch(updateInputFieldDataSuccess());
    })
    .catch(err => { throw err; });
};

export const updateSourceColumn = (id, data, index) => dispatch => {
  axios.put(url+colUrl, { id, confirmedValue: data })
    .then(() => {
      dispatch(updateSourceColumnSuccess(data, index));
    })
    .catch(err => { throw err; });
};

export const updateTargetColumn = (id, data) => dispatch => {
  axios.put(url+colUrl, { id, confirmedValue: data })
    .then(() => {
      dispatch(updateTargetColumnSuccess(data));
    })
    .catch(err => { throw err; });
};

export const updateTranslationTable = (field, value) => ({ type: UPDATE_TRANSLATION_TABLE, field, value });

export const saveTranslationTable = ({ id, name, description }) => (dispatch, getState) => {
  dispatch(savingTranslationTable());
  axios.put(url, { id, name, description })
    .then(() => {
      dispatch(saveTranslationTableSuccess({ id, name, description }));
      if (!getState().translationTable.translationTableEditionMode) {
        dispatch(addUnconfirmedTranslationTable({ id, name, description }));
      }
    })
    .catch(err => { throw err; });
};

export const deleteRow = (id, translationTableId) => dispatch => {
  dispatch(clearRows());
  axios.delete(`${ url+translateDataUrl }/${ id }`)
    .then(() => {
      dispatch(fetchTranslationTableData(translationTableId));
    })
    .catch(err => { throw err; });
};

export const createMatchColListItem = sourceInputId => dispatch => {
  dispatch(changingColList());
  axios.get(`${ url+matchColsList+matchCols }/${ sourceInputId }`)
    .then(response => {
      dispatch(changingColListSuccess());
      dispatch(createMatchColListItemSuccess(response.data.data, sourceInputId));
    })
    .catch(err => { throw err; });
};

export const updateMatchColListItem = (id, matchValue, sourceInputId) => dispatch => {
  dispatch(changingColList());
  axios.put(url+matchColsList, { id, confirmedValue: matchValue })
    .then(response => {
      dispatch(changingColListSuccess());
      dispatch(updateMatchColListItemSuccess(response.data.data, sourceInputId));
    })
    .catch(err => { throw err; });
};

export const deleteMatchColListItem = (id, sourceInputId) => dispatch => {
  dispatch(clearMatchColListItems());
  axios.delete(`${url+matchColsList}/${id}`)
    .then(() => {
      dispatch(fetchMatchColListItem(sourceInputId));
      dispatch(deleteMatchColListItemSuccess(id, sourceInputId));
    })
    .catch(err => { throw err; });
};

export const fetchMatchColListItem = sourceInputId => dispatch => {
  dispatch(fetchingTranslationTableData());
  axios.get(`${url+matchColsList}/${ sourceInputId }`)
    .then(response => {
      dispatch(fetchMatchColListItemSuccess(response.data.data, sourceInputId));
    })
    .catch(err => { throw err; });
};

export const saveMatchColList = sourceInputId => (dispatch, getState) => {
  const tTableId = getState().translationTable.translationTable.id;
  axios.put(`${ url+matchColsList+matchCols }/${ sourceInputId }?${consolidated}=true`)
    .then(() => {
      dispatch(saveMatchColListSuccess(sourceInputId));
      dispatch(clearRows());
      dispatch(fetchTranslationTableData(tTableId));
    });
};

export const cancelMatchColList = sourceInputId => (dispatch, getState) => {
  const tTableId = getState().translationTable.translationTable.id;
  axios.put(`${url + matchColsList + matchCols}/${sourceInputId}?${consolidated}=false`)
    .then(() => {
      dispatch(cancelMatchColListSuccess(sourceInputId));
      dispatch(clearRows());
      dispatch(fetchTranslationTableData(tTableId));
    });
};

export const uploadFileTTRows  = (files, additionalInformation) => dispatch => {
  const uploadSuccess = (rowsCreated) => { 
    dispatch(clearRows());
    dispatch(createRowSuccess(rowsCreated));
  };
  uploadFiles({
    files,
    additionalInformation,
    url: `${url + ttFileList}`,
    onComplete: uploadSuccess
  })(dispatch);
};

export const uploadFileTTListItems  = (files, additionalInformation, sourceInputId) => dispatch => {
  const uploadSuccess = (matchColListItems) => { 
    dispatch(changingColListSuccess());
    dispatch(fetchMatchColListItemSuccess(matchColListItems, sourceInputId));
  };
  dispatch(changingColList());
  uploadFiles({
    files,
    additionalInformation,
    url: `${url + matchColsList + fileList}`,
    onComplete: uploadSuccess
  })(dispatch);
};

export const fetchTranslationTable = translationTableId => dispatch => {
  dispatch(fetchingTranslationTable());
  axios.get(`${ url }/${ translationTableId }`)
    .then(response => {
      dispatch(fetchTranslationTableSuccess(response.data.data));
    })
    .catch(err => { throw err; });
};



// WEBPACK FOOTER //
// ./src/redux/translationTable/TranslationTableActions.js